export default class Locale_Projects { 
	SearchPlaceholder: string = "Search Projects..";
	EntityPropertySelectorPlaceholder: string = "Select property to order by..";
	TertiaryText = {
		All: 'All',
		Team: 'Team'
	};
	ProjectHasUnseenChanges: string = "The project has unseen changes";
}